var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mail-list"},[_c('div',{staticClass:"msg-page-in-dev"},[_vm._v("У вас нет черновиков")])])
}]

export { render, staticRenderFns }